export default "__VITE_ASSET__82585030__"